module.exports = __webpack_public_path__ + "img/img_phone5_APP.b8681ee9.png";